import { Flex, Stack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import theme from 'theme'

export type NotificationToastProps = {
  status: 'success' | 'error'
  text: string
  isClosable?: boolean
  onClose?: () => void
}

const TOAST_MIN_HEIGHT = '56px'
const TOAST_MAX_WIDTH = '348px'

const NotificationToast = ({ status, text, isClosable, onClose }: NotificationToastProps) => {
  return (
    <Stack
      background={theme.colors.alpha.blackalpha['800']}
      direction="row"
      align="center"
      justify="space-between"
      p="0 12px"
      minH={TOAST_MIN_HEIGHT}
      maxW={TOAST_MAX_WIDTH}
      borderRadius={theme.radii.base}
    >
      <Stack direction="row" align="center" spacing="12px">
        <FontAwesomeIcon
          icon={['fas', status === 'error' ? 'circle-exclamation' : 'circle-check']}
          size="lg"
          color={status === 'error' ? theme.baseColors.danger.main : theme.baseColors.success.dark}
        />
        <Text color={theme.colors.white} fontSize="16px" lineHeight="20px">
          {text}
        </Text>
      </Stack>
      {isClosable && (
        <Flex px="12px" h={TOAST_MIN_HEIGHT} align="center" cursor="pointer" onClick={onClose}>
          <FontAwesomeIcon icon={['far', 'xmark']} size="lg" color={theme.colors.white} />
        </Flex>
      )}
    </Stack>
  )
}

export default NotificationToast
